import { useQuery } from '@apollo/client'
import { Hidden } from '@material-ui/core'
import { matchSorter } from 'match-sorter'
import { useEffect, useMemo, useState } from 'react'

import PageHeader from '../../components/PageHeader'
import { PAYMENT_TERMS_QUERY } from '../../graphql/walletPaymentTerm'
import { getTranslate } from '../../localization'
import { PaymentTermBrief } from '../../types/walletPaymentTerm'
import PaymentTermsHeader from './PaymentTermHeader'
import PaymentTermListDesktop from './PaymentTermListDesktop'
import PaymentTermListMobile from './PaymentTermListMobile'

const PaymentTermList = () => {
  const [searchInputValue, setsearchInputValue] = useState<string>('')
  const [page, setPage] = useState(1)
  const [count, setcount] = useState(0)
  const [filteredPaymentTerms, setfilteredPaymentTerms] = useState<
    PaymentTermBrief[]
  >([])
  const {
    data: paymentTerms,
    loading,
    refetch
  } = useQuery<{ paymentTerms: PaymentTermBrief[] }>(PAYMENT_TERMS_QUERY, {
    notifyOnNetworkStatusChange: true
  })
  const [perPage] = useState(5)

  const numberOfPages = useMemo(() => Math.ceil(count / perPage), [count])

  useEffect(() => {
    setPage(1)
    const fullPaymentTermsList = paymentTerms?.paymentTerms
      ? paymentTerms?.paymentTerms
      : []
    const newFilteredPaymentTerms = matchSorter(
      fullPaymentTermsList,
      searchInputValue,
      {
        keys: ['name', 'code'],
        sorter: (rankedItems) =>
          rankedItems.sort((a, b) => {
            return a.item.name > b.item.name ? 1 : -1
          })
      }
    )
    setfilteredPaymentTerms(newFilteredPaymentTerms)
    setcount(newFilteredPaymentTerms.length)
  }, [searchInputValue, loading])

  return (
    <>
      <PageHeader title={getTranslate('Payment Term List')} />
      <PaymentTermsHeader
        searchInputValue={searchInputValue}
        setsearchInputValue={setsearchInputValue}
      />
      <Hidden smDown>
        <PaymentTermListDesktop
          refetch={refetch}
          filteredPaymentTerms={filteredPaymentTerms}
          page={page}
          perPage={perPage}
          loading={loading}
          numberOfPages={numberOfPages}
          setPage={setPage}
        />
      </Hidden>
      <Hidden mdUp>
        <PaymentTermListMobile
          refetch={refetch}
          filteredPaymentTerms={filteredPaymentTerms}
          page={page}
          perPage={perPage}
          loading={loading}
          numberOfPages={numberOfPages}
          setPage={setPage}
        />
      </Hidden>
    </>
  )
}
export default PaymentTermList
